/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { CrmDashboardDtoBaseResponse } from '../models/crm-dashboard-dto-base-response';
import { DealCategory } from '../models/deal-category';
import { DealCommentDto } from '../models/deal-comment-dto';
import { DealCommentDtoBaseResponse } from '../models/deal-comment-dto-base-response';
import { DealCommentDtoListBaseResponse } from '../models/deal-comment-dto-list-base-response';
import { DealDto } from '../models/deal-dto';
import { DealDtoBaseResponse } from '../models/deal-dto-base-response';
import { DealDtoListBaseResponse } from '../models/deal-dto-list-base-response';
import { DealReminderDto } from '../models/deal-reminder-dto';
import { DealReminderDtoBaseResponse } from '../models/deal-reminder-dto-base-response';
import { DealReminderDtoListBaseResponse } from '../models/deal-reminder-dto-list-base-response';
import { DealStageDetailDto } from '../models/deal-stage-detail-dto';
import { DealStageDetailDtoListBaseResponse } from '../models/deal-stage-detail-dto-list-base-response';
import { DealStageDto } from '../models/deal-stage-dto';
import { DealStageDtoBaseResponse } from '../models/deal-stage-dto-base-response';
import { DealStageDtoListBaseResponse } from '../models/deal-stage-dto-list-base-response';
import { EnquiryDto } from '../models/enquiry-dto';
import { LeadStatsDtoBaseResponse } from '../models/lead-stats-dto-base-response';
import { MarinePartDto } from '../models/marine-part-dto';
import { MarinePartDtoBaseResponse } from '../models/marine-part-dto-base-response';
import { MarinePartDtoListBaseResponse } from '../models/marine-part-dto-list-base-response';
import { PipelineSectionDto } from '../models/pipeline-section-dto';
import { PipelineSectionDtoBaseResponse } from '../models/pipeline-section-dto-base-response';
import { PipelineSectionDtoListBaseResponse } from '../models/pipeline-section-dto-list-base-response';
import { QuoteFileDto } from '../models/quote-file-dto';
import { QuoteFileDtoBaseResponse } from '../models/quote-file-dto-base-response';
import { QuoteFileDtoListBaseResponse } from '../models/quote-file-dto-list-base-response';
import { QuoteStatsDtoBaseResponse } from '../models/quote-stats-dto-base-response';
import { SalesPipelineForecastDtoBaseResponse } from '../models/sales-pipeline-forecast-dto-base-response';
import { StringBaseResponse } from '../models/string-base-response';

@Injectable({
  providedIn: 'root',
})
export class DealService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiDealSectionsGet
   */
  static readonly ApiDealSectionsGetPath = '/api/Deal/sections';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealSectionsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealSectionsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<PipelineSectionDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealSectionsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PipelineSectionDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealSectionsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealSectionsGet$Plain(params?: {
  }): Observable<PipelineSectionDtoListBaseResponse> {

    return this.apiDealSectionsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PipelineSectionDtoListBaseResponse>) => r.body as PipelineSectionDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealSectionsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealSectionsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<PipelineSectionDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealSectionsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PipelineSectionDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealSectionsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealSectionsGet$Json(params?: {
  }): Observable<PipelineSectionDtoListBaseResponse> {

    return this.apiDealSectionsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PipelineSectionDtoListBaseResponse>) => r.body as PipelineSectionDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealCompanyDealsGet
   */
  static readonly ApiDealCompanyDealsGetPath = '/api/Deal/company-deals';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealCompanyDealsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealCompanyDealsGet$Plain$Response(params?: {
    companyId?: number;
  }): Observable<StrictHttpResponse<DealDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealCompanyDealsGetPath, 'get');
    if (params) {
      rb.query('companyId', params.companyId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealCompanyDealsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealCompanyDealsGet$Plain(params?: {
    companyId?: number;
  }): Observable<DealDtoListBaseResponse> {

    return this.apiDealCompanyDealsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealDtoListBaseResponse>) => r.body as DealDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealCompanyDealsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealCompanyDealsGet$Json$Response(params?: {
    companyId?: number;
  }): Observable<StrictHttpResponse<DealDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealCompanyDealsGetPath, 'get');
    if (params) {
      rb.query('companyId', params.companyId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealCompanyDealsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealCompanyDealsGet$Json(params?: {
    companyId?: number;
  }): Observable<DealDtoListBaseResponse> {

    return this.apiDealCompanyDealsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealDtoListBaseResponse>) => r.body as DealDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealAddSectionPost
   */
  static readonly ApiDealAddSectionPostPath = '/api/Deal/add-section';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddSectionPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddSectionPost$Plain$Response(params?: {
    body?: PipelineSectionDto
  }): Observable<StrictHttpResponse<PipelineSectionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddSectionPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PipelineSectionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddSectionPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddSectionPost$Plain(params?: {
    body?: PipelineSectionDto
  }): Observable<PipelineSectionDtoBaseResponse> {

    return this.apiDealAddSectionPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PipelineSectionDtoBaseResponse>) => r.body as PipelineSectionDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddSectionPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddSectionPost$Json$Response(params?: {
    body?: PipelineSectionDto
  }): Observable<StrictHttpResponse<PipelineSectionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddSectionPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PipelineSectionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddSectionPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddSectionPost$Json(params?: {
    body?: PipelineSectionDto
  }): Observable<PipelineSectionDtoBaseResponse> {

    return this.apiDealAddSectionPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PipelineSectionDtoBaseResponse>) => r.body as PipelineSectionDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealUpdateSectionPut
   */
  static readonly ApiDealUpdateSectionPutPath = '/api/Deal/update-section';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateSectionPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateSectionPut$Plain$Response(params?: {
    body?: PipelineSectionDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateSectionPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateSectionPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateSectionPut$Plain(params?: {
    body?: PipelineSectionDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateSectionPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateSectionPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateSectionPut$Json$Response(params?: {
    body?: PipelineSectionDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateSectionPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateSectionPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateSectionPut$Json(params?: {
    body?: PipelineSectionDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateSectionPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealArchiveSectionDelete
   */
  static readonly ApiDealArchiveSectionDeletePath = '/api/Deal/archive-section';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealArchiveSectionDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveSectionDelete$Plain$Response(params?: {
    pipelineSectionId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealArchiveSectionDeletePath, 'delete');
    if (params) {
      rb.query('pipelineSectionId', params.pipelineSectionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealArchiveSectionDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveSectionDelete$Plain(params?: {
    pipelineSectionId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiDealArchiveSectionDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealArchiveSectionDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveSectionDelete$Json$Response(params?: {
    pipelineSectionId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealArchiveSectionDeletePath, 'delete');
    if (params) {
      rb.query('pipelineSectionId', params.pipelineSectionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealArchiveSectionDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveSectionDelete$Json(params?: {
    pipelineSectionId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiDealArchiveSectionDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealDealGet
   */
  static readonly ApiDealDealGetPath = '/api/Deal/deal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDealGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDealGet$Plain$Response(params?: {
    dealId?: number;
  }): Observable<StrictHttpResponse<DealDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDealGetPath, 'get');
    if (params) {
      rb.query('dealId', params.dealId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDealGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDealGet$Plain(params?: {
    dealId?: number;
  }): Observable<DealDtoBaseResponse> {

    return this.apiDealDealGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealDtoBaseResponse>) => r.body as DealDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDealGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDealGet$Json$Response(params?: {
    dealId?: number;
  }): Observable<StrictHttpResponse<DealDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDealGetPath, 'get');
    if (params) {
      rb.query('dealId', params.dealId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDealGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDealGet$Json(params?: {
    dealId?: number;
  }): Observable<DealDtoBaseResponse> {

    return this.apiDealDealGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealDtoBaseResponse>) => r.body as DealDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealAddDealPost
   */
  static readonly ApiDealAddDealPostPath = '/api/Deal/add-deal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddDealPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddDealPost$Plain$Response(params?: {
    body?: DealDto
  }): Observable<StrictHttpResponse<DealDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddDealPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddDealPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddDealPost$Plain(params?: {
    body?: DealDto
  }): Observable<DealDtoBaseResponse> {

    return this.apiDealAddDealPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealDtoBaseResponse>) => r.body as DealDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddDealPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddDealPost$Json$Response(params?: {
    body?: DealDto
  }): Observable<StrictHttpResponse<DealDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddDealPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddDealPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddDealPost$Json(params?: {
    body?: DealDto
  }): Observable<DealDtoBaseResponse> {

    return this.apiDealAddDealPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealDtoBaseResponse>) => r.body as DealDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealUpdateDealPut
   */
  static readonly ApiDealUpdateDealPutPath = '/api/Deal/update-deal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateDealPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateDealPut$Plain$Response(params?: {
    body?: DealDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateDealPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateDealPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateDealPut$Plain(params?: {
    body?: DealDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateDealPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateDealPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateDealPut$Json$Response(params?: {
    body?: DealDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateDealPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateDealPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateDealPut$Json(params?: {
    body?: DealDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateDealPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealUpdateQuoteDealPut
   */
  static readonly ApiDealUpdateQuoteDealPutPath = '/api/Deal/update-quote-deal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateQuoteDealPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateQuoteDealPut$Plain$Response(params?: {
    body?: DealDto
  }): Observable<StrictHttpResponse<DealDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateQuoteDealPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateQuoteDealPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateQuoteDealPut$Plain(params?: {
    body?: DealDto
  }): Observable<DealDtoBaseResponse> {

    return this.apiDealUpdateQuoteDealPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealDtoBaseResponse>) => r.body as DealDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateQuoteDealPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateQuoteDealPut$Json$Response(params?: {
    body?: DealDto
  }): Observable<StrictHttpResponse<DealDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateQuoteDealPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateQuoteDealPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateQuoteDealPut$Json(params?: {
    body?: DealDto
  }): Observable<DealDtoBaseResponse> {

    return this.apiDealUpdateQuoteDealPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealDtoBaseResponse>) => r.body as DealDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealSendSalesNotificationPut
   */
  static readonly ApiDealSendSalesNotificationPutPath = '/api/Deal/send-sales-notification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealSendSalesNotificationPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealSendSalesNotificationPut$Plain$Response(params?: {
    userId?: number;
    body?: DealDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealSendSalesNotificationPutPath, 'put');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealSendSalesNotificationPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealSendSalesNotificationPut$Plain(params?: {
    userId?: number;
    body?: DealDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealSendSalesNotificationPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealSendSalesNotificationPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealSendSalesNotificationPut$Json$Response(params?: {
    userId?: number;
    body?: DealDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealSendSalesNotificationPutPath, 'put');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealSendSalesNotificationPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealSendSalesNotificationPut$Json(params?: {
    userId?: number;
    body?: DealDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealSendSalesNotificationPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealSendCustomerQuoteEmailPost
   */
  static readonly ApiDealSendCustomerQuoteEmailPostPath = '/api/Deal/send-customer-quote-email';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealSendCustomerQuoteEmailPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiDealSendCustomerQuoteEmailPost$Plain$Response(params?: {
    fileName?: string;
    emailTo?: string;
    emailSubject?: string;
    emailBody?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealSendCustomerQuoteEmailPostPath, 'post');
    if (params) {
      rb.query('fileName', params.fileName, {});
      rb.query('emailTo', params.emailTo, {});
      rb.query('emailSubject', params.emailSubject, {});
      rb.query('emailBody', params.emailBody, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealSendCustomerQuoteEmailPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiDealSendCustomerQuoteEmailPost$Plain(params?: {
    fileName?: string;
    emailTo?: string;
    emailSubject?: string;
    emailBody?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<BooleanBaseResponse> {

    return this.apiDealSendCustomerQuoteEmailPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealSendCustomerQuoteEmailPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiDealSendCustomerQuoteEmailPost$Json$Response(params?: {
    fileName?: string;
    emailTo?: string;
    emailSubject?: string;
    emailBody?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealSendCustomerQuoteEmailPostPath, 'post');
    if (params) {
      rb.query('fileName', params.fileName, {});
      rb.query('emailTo', params.emailTo, {});
      rb.query('emailSubject', params.emailSubject, {});
      rb.query('emailBody', params.emailBody, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealSendCustomerQuoteEmailPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiDealSendCustomerQuoteEmailPost$Json(params?: {
    fileName?: string;
    emailTo?: string;
    emailSubject?: string;
    emailBody?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<BooleanBaseResponse> {

    return this.apiDealSendCustomerQuoteEmailPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealUpdateDealExcludeFromKpisPut
   */
  static readonly ApiDealUpdateDealExcludeFromKpisPutPath = '/api/Deal/update-deal-exclude-from-kpis';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateDealExcludeFromKpisPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateDealExcludeFromKpisPut$Plain$Response(params?: {
    body?: DealDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateDealExcludeFromKpisPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateDealExcludeFromKpisPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateDealExcludeFromKpisPut$Plain(params?: {
    body?: DealDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateDealExcludeFromKpisPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateDealExcludeFromKpisPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateDealExcludeFromKpisPut$Json$Response(params?: {
    body?: DealDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateDealExcludeFromKpisPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateDealExcludeFromKpisPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateDealExcludeFromKpisPut$Json(params?: {
    body?: DealDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateDealExcludeFromKpisPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealArchiveDealDelete
   */
  static readonly ApiDealArchiveDealDeletePath = '/api/Deal/archive-deal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealArchiveDealDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveDealDelete$Plain$Response(params?: {
    dealId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealArchiveDealDeletePath, 'delete');
    if (params) {
      rb.query('dealId', params.dealId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealArchiveDealDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveDealDelete$Plain(params?: {
    dealId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiDealArchiveDealDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealArchiveDealDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveDealDelete$Json$Response(params?: {
    dealId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealArchiveDealDeletePath, 'delete');
    if (params) {
      rb.query('dealId', params.dealId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealArchiveDealDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveDealDelete$Json(params?: {
    dealId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiDealArchiveDealDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealQuoteRefGet
   */
  static readonly ApiDealQuoteRefGetPath = '/api/Deal/quote-ref';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealQuoteRefGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealQuoteRefGet$Plain$Response(params?: {
    dealId?: number;
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealQuoteRefGetPath, 'get');
    if (params) {
      rb.query('dealId', params.dealId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealQuoteRefGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealQuoteRefGet$Plain(params?: {
    dealId?: number;
  }): Observable<StringBaseResponse> {

    return this.apiDealQuoteRefGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealQuoteRefGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealQuoteRefGet$Json$Response(params?: {
    dealId?: number;
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealQuoteRefGetPath, 'get');
    if (params) {
      rb.query('dealId', params.dealId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealQuoteRefGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealQuoteRefGet$Json(params?: {
    dealId?: number;
  }): Observable<StringBaseResponse> {

    return this.apiDealQuoteRefGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealNextQuoteRefGet
   */
  static readonly ApiDealNextQuoteRefGetPath = '/api/Deal/next-quote-ref';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealNextQuoteRefGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealNextQuoteRefGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealNextQuoteRefGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealNextQuoteRefGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealNextQuoteRefGet$Plain(params?: {
  }): Observable<StringBaseResponse> {

    return this.apiDealNextQuoteRefGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealNextQuoteRefGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealNextQuoteRefGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealNextQuoteRefGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealNextQuoteRefGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealNextQuoteRefGet$Json(params?: {
  }): Observable<StringBaseResponse> {

    return this.apiDealNextQuoteRefGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealNextNonWonQuoteRefGet
   */
  static readonly ApiDealNextNonWonQuoteRefGetPath = '/api/Deal/next-non-won-quote-ref';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealNextNonWonQuoteRefGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealNextNonWonQuoteRefGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealNextNonWonQuoteRefGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealNextNonWonQuoteRefGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealNextNonWonQuoteRefGet$Plain(params?: {
  }): Observable<StringBaseResponse> {

    return this.apiDealNextNonWonQuoteRefGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealNextNonWonQuoteRefGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealNextNonWonQuoteRefGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealNextNonWonQuoteRefGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealNextNonWonQuoteRefGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealNextNonWonQuoteRefGet$Json(params?: {
  }): Observable<StringBaseResponse> {

    return this.apiDealNextNonWonQuoteRefGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealStagesGet
   */
  static readonly ApiDealStagesGetPath = '/api/Deal/stages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealStagesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealStagesGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<DealStageDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealStagesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealStageDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealStagesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealStagesGet$Plain(params?: {
  }): Observable<DealStageDtoListBaseResponse> {

    return this.apiDealStagesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealStageDtoListBaseResponse>) => r.body as DealStageDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealStagesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealStagesGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<DealStageDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealStagesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealStageDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealStagesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealStagesGet$Json(params?: {
  }): Observable<DealStageDtoListBaseResponse> {

    return this.apiDealStagesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealStageDtoListBaseResponse>) => r.body as DealStageDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealDealsByStageGet
   */
  static readonly ApiDealDealsByStageGetPath = '/api/Deal/deals-by-stage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDealsByStageGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDealsByStageGet$Plain$Response(params?: {

    /**
     * 0 &#x3D; StandardProducts
     * 
     * 1 &#x3D; CustomProducts
     * 
     * 2 &#x3D; CableWorkingGear
     * 
     * 3 &#x3D; Hire
     * 
     * 4 &#x3D; MarineSales
     * 
     * 5 &#x3D; Grapnels
     * 
     * 6 &#x3D; NewLead
     * 
     * 7 &#x3D; RepeatCustomProduct
     */
    category?: DealCategory;
    searchText?: string;
  }): Observable<StrictHttpResponse<DealStageDetailDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDealsByStageGetPath, 'get');
    if (params) {
      rb.query('category', params.category, {});
      rb.query('searchText', params.searchText, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealStageDetailDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDealsByStageGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDealsByStageGet$Plain(params?: {

    /**
     * 0 &#x3D; StandardProducts
     * 
     * 1 &#x3D; CustomProducts
     * 
     * 2 &#x3D; CableWorkingGear
     * 
     * 3 &#x3D; Hire
     * 
     * 4 &#x3D; MarineSales
     * 
     * 5 &#x3D; Grapnels
     * 
     * 6 &#x3D; NewLead
     * 
     * 7 &#x3D; RepeatCustomProduct
     */
    category?: DealCategory;
    searchText?: string;
  }): Observable<DealStageDetailDtoListBaseResponse> {

    return this.apiDealDealsByStageGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealStageDetailDtoListBaseResponse>) => r.body as DealStageDetailDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDealsByStageGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDealsByStageGet$Json$Response(params?: {

    /**
     * 0 &#x3D; StandardProducts
     * 
     * 1 &#x3D; CustomProducts
     * 
     * 2 &#x3D; CableWorkingGear
     * 
     * 3 &#x3D; Hire
     * 
     * 4 &#x3D; MarineSales
     * 
     * 5 &#x3D; Grapnels
     * 
     * 6 &#x3D; NewLead
     * 
     * 7 &#x3D; RepeatCustomProduct
     */
    category?: DealCategory;
    searchText?: string;
  }): Observable<StrictHttpResponse<DealStageDetailDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDealsByStageGetPath, 'get');
    if (params) {
      rb.query('category', params.category, {});
      rb.query('searchText', params.searchText, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealStageDetailDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDealsByStageGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDealsByStageGet$Json(params?: {

    /**
     * 0 &#x3D; StandardProducts
     * 
     * 1 &#x3D; CustomProducts
     * 
     * 2 &#x3D; CableWorkingGear
     * 
     * 3 &#x3D; Hire
     * 
     * 4 &#x3D; MarineSales
     * 
     * 5 &#x3D; Grapnels
     * 
     * 6 &#x3D; NewLead
     * 
     * 7 &#x3D; RepeatCustomProduct
     */
    category?: DealCategory;
    searchText?: string;
  }): Observable<DealStageDetailDtoListBaseResponse> {

    return this.apiDealDealsByStageGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealStageDetailDtoListBaseResponse>) => r.body as DealStageDetailDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealAddStagePost
   */
  static readonly ApiDealAddStagePostPath = '/api/Deal/add-stage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddStagePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddStagePost$Plain$Response(params?: {
    body?: DealStageDto
  }): Observable<StrictHttpResponse<DealStageDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddStagePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealStageDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddStagePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddStagePost$Plain(params?: {
    body?: DealStageDto
  }): Observable<DealStageDtoBaseResponse> {

    return this.apiDealAddStagePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealStageDtoBaseResponse>) => r.body as DealStageDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddStagePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddStagePost$Json$Response(params?: {
    body?: DealStageDto
  }): Observable<StrictHttpResponse<DealStageDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddStagePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealStageDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddStagePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddStagePost$Json(params?: {
    body?: DealStageDto
  }): Observable<DealStageDtoBaseResponse> {

    return this.apiDealAddStagePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealStageDtoBaseResponse>) => r.body as DealStageDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealUpdateStagePut
   */
  static readonly ApiDealUpdateStagePutPath = '/api/Deal/update-stage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateStagePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateStagePut$Plain$Response(params?: {
    body?: DealStageDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateStagePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateStagePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateStagePut$Plain(params?: {
    body?: DealStageDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateStagePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateStagePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateStagePut$Json$Response(params?: {
    body?: DealStageDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateStagePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateStagePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateStagePut$Json(params?: {
    body?: DealStageDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateStagePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealDeleteStageDelete
   */
  static readonly ApiDealDeleteStageDeletePath = '/api/Deal/delete-stage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDeleteStageDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDeleteStageDelete$Plain$Response(params?: {
    stageId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDeleteStageDeletePath, 'delete');
    if (params) {
      rb.query('stageId', params.stageId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDeleteStageDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDeleteStageDelete$Plain(params?: {
    stageId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiDealDeleteStageDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDeleteStageDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDeleteStageDelete$Json$Response(params?: {
    stageId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDeleteStageDeletePath, 'delete');
    if (params) {
      rb.query('stageId', params.stageId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDeleteStageDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDeleteStageDelete$Json(params?: {
    stageId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiDealDeleteStageDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealForecastPost
   */
  static readonly ApiDealForecastPostPath = '/api/Deal/forecast';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealForecastPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealForecastPost$Plain$Response(params?: {
    startDate?: string;
    months?: number;
    body?: Array<DealCategory>
  }): Observable<StrictHttpResponse<SalesPipelineForecastDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealForecastPostPath, 'post');
    if (params) {
      rb.query('startDate', params.startDate, {});
      rb.query('months', params.months, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SalesPipelineForecastDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealForecastPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealForecastPost$Plain(params?: {
    startDate?: string;
    months?: number;
    body?: Array<DealCategory>
  }): Observable<SalesPipelineForecastDtoBaseResponse> {

    return this.apiDealForecastPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SalesPipelineForecastDtoBaseResponse>) => r.body as SalesPipelineForecastDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealForecastPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealForecastPost$Json$Response(params?: {
    startDate?: string;
    months?: number;
    body?: Array<DealCategory>
  }): Observable<StrictHttpResponse<SalesPipelineForecastDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealForecastPostPath, 'post');
    if (params) {
      rb.query('startDate', params.startDate, {});
      rb.query('months', params.months, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SalesPipelineForecastDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealForecastPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealForecastPost$Json(params?: {
    startDate?: string;
    months?: number;
    body?: Array<DealCategory>
  }): Observable<SalesPipelineForecastDtoBaseResponse> {

    return this.apiDealForecastPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SalesPipelineForecastDtoBaseResponse>) => r.body as SalesPipelineForecastDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealDashboardStatsGet
   */
  static readonly ApiDealDashboardStatsGetPath = '/api/Deal/dashboard-stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDashboardStatsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDashboardStatsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<CrmDashboardDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDashboardStatsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CrmDashboardDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDashboardStatsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDashboardStatsGet$Plain(params?: {
  }): Observable<CrmDashboardDtoBaseResponse> {

    return this.apiDealDashboardStatsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CrmDashboardDtoBaseResponse>) => r.body as CrmDashboardDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDashboardStatsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDashboardStatsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<CrmDashboardDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDashboardStatsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CrmDashboardDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDashboardStatsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDashboardStatsGet$Json(params?: {
  }): Observable<CrmDashboardDtoBaseResponse> {

    return this.apiDealDashboardStatsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CrmDashboardDtoBaseResponse>) => r.body as CrmDashboardDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealQuoteStatsGet
   */
  static readonly ApiDealQuoteStatsGetPath = '/api/Deal/quote-stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealQuoteStatsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealQuoteStatsGet$Plain$Response(params?: {
    start?: string;
    end?: string;
  }): Observable<StrictHttpResponse<QuoteStatsDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealQuoteStatsGetPath, 'get');
    if (params) {
      rb.query('start', params.start, {});
      rb.query('end', params.end, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuoteStatsDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealQuoteStatsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealQuoteStatsGet$Plain(params?: {
    start?: string;
    end?: string;
  }): Observable<QuoteStatsDtoBaseResponse> {

    return this.apiDealQuoteStatsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<QuoteStatsDtoBaseResponse>) => r.body as QuoteStatsDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealQuoteStatsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealQuoteStatsGet$Json$Response(params?: {
    start?: string;
    end?: string;
  }): Observable<StrictHttpResponse<QuoteStatsDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealQuoteStatsGetPath, 'get');
    if (params) {
      rb.query('start', params.start, {});
      rb.query('end', params.end, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuoteStatsDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealQuoteStatsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealQuoteStatsGet$Json(params?: {
    start?: string;
    end?: string;
  }): Observable<QuoteStatsDtoBaseResponse> {

    return this.apiDealQuoteStatsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<QuoteStatsDtoBaseResponse>) => r.body as QuoteStatsDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealLeadStatsGet
   */
  static readonly ApiDealLeadStatsGetPath = '/api/Deal/lead-stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealLeadStatsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealLeadStatsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<LeadStatsDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealLeadStatsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LeadStatsDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealLeadStatsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealLeadStatsGet$Plain(params?: {
  }): Observable<LeadStatsDtoBaseResponse> {

    return this.apiDealLeadStatsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<LeadStatsDtoBaseResponse>) => r.body as LeadStatsDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealLeadStatsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealLeadStatsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<LeadStatsDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealLeadStatsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LeadStatsDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealLeadStatsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealLeadStatsGet$Json(params?: {
  }): Observable<LeadStatsDtoBaseResponse> {

    return this.apiDealLeadStatsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<LeadStatsDtoBaseResponse>) => r.body as LeadStatsDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealMarinePartsGet
   */
  static readonly ApiDealMarinePartsGetPath = '/api/Deal/marine-parts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealMarinePartsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealMarinePartsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<MarinePartDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealMarinePartsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MarinePartDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealMarinePartsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealMarinePartsGet$Plain(params?: {
  }): Observable<MarinePartDtoListBaseResponse> {

    return this.apiDealMarinePartsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<MarinePartDtoListBaseResponse>) => r.body as MarinePartDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealMarinePartsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealMarinePartsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<MarinePartDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealMarinePartsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MarinePartDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealMarinePartsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealMarinePartsGet$Json(params?: {
  }): Observable<MarinePartDtoListBaseResponse> {

    return this.apiDealMarinePartsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MarinePartDtoListBaseResponse>) => r.body as MarinePartDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealAddMarinePartPost
   */
  static readonly ApiDealAddMarinePartPostPath = '/api/Deal/add-marine-part';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddMarinePartPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddMarinePartPost$Plain$Response(params?: {
    body?: MarinePartDto
  }): Observable<StrictHttpResponse<MarinePartDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddMarinePartPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MarinePartDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddMarinePartPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddMarinePartPost$Plain(params?: {
    body?: MarinePartDto
  }): Observable<MarinePartDtoBaseResponse> {

    return this.apiDealAddMarinePartPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<MarinePartDtoBaseResponse>) => r.body as MarinePartDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddMarinePartPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddMarinePartPost$Json$Response(params?: {
    body?: MarinePartDto
  }): Observable<StrictHttpResponse<MarinePartDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddMarinePartPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MarinePartDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddMarinePartPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddMarinePartPost$Json(params?: {
    body?: MarinePartDto
  }): Observable<MarinePartDtoBaseResponse> {

    return this.apiDealAddMarinePartPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<MarinePartDtoBaseResponse>) => r.body as MarinePartDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealUpdateMarinePartPut
   */
  static readonly ApiDealUpdateMarinePartPutPath = '/api/Deal/update-marine-part';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateMarinePartPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateMarinePartPut$Plain$Response(params?: {
    body?: MarinePartDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateMarinePartPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateMarinePartPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateMarinePartPut$Plain(params?: {
    body?: MarinePartDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateMarinePartPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateMarinePartPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateMarinePartPut$Json$Response(params?: {
    body?: MarinePartDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateMarinePartPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateMarinePartPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateMarinePartPut$Json(params?: {
    body?: MarinePartDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateMarinePartPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealArchiveMarinePartDelete
   */
  static readonly ApiDealArchiveMarinePartDeletePath = '/api/Deal/archive-marine-part';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealArchiveMarinePartDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveMarinePartDelete$Plain$Response(params?: {
    marinePartId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealArchiveMarinePartDeletePath, 'delete');
    if (params) {
      rb.query('marinePartId', params.marinePartId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealArchiveMarinePartDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveMarinePartDelete$Plain(params?: {
    marinePartId?: number;
    archive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiDealArchiveMarinePartDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealArchiveMarinePartDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveMarinePartDelete$Json$Response(params?: {
    marinePartId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealArchiveMarinePartDeletePath, 'delete');
    if (params) {
      rb.query('marinePartId', params.marinePartId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealArchiveMarinePartDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveMarinePartDelete$Json(params?: {
    marinePartId?: number;
    archive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiDealArchiveMarinePartDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealGetFilesGet
   */
  static readonly ApiDealGetFilesGetPath = '/api/Deal/get-files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealGetFilesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealGetFilesGet$Plain$Response(params?: {
    dealId?: number;
  }): Observable<StrictHttpResponse<QuoteFileDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealGetFilesGetPath, 'get');
    if (params) {
      rb.query('dealId', params.dealId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuoteFileDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealGetFilesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealGetFilesGet$Plain(params?: {
    dealId?: number;
  }): Observable<QuoteFileDtoListBaseResponse> {

    return this.apiDealGetFilesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<QuoteFileDtoListBaseResponse>) => r.body as QuoteFileDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealGetFilesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealGetFilesGet$Json$Response(params?: {
    dealId?: number;
  }): Observable<StrictHttpResponse<QuoteFileDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealGetFilesGetPath, 'get');
    if (params) {
      rb.query('dealId', params.dealId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuoteFileDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealGetFilesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealGetFilesGet$Json(params?: {
    dealId?: number;
  }): Observable<QuoteFileDtoListBaseResponse> {

    return this.apiDealGetFilesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<QuoteFileDtoListBaseResponse>) => r.body as QuoteFileDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealUploadFileDealIdPost
   */
  static readonly ApiDealUploadFileDealIdPostPath = '/api/Deal/upload-file/{dealId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUploadFileDealIdPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiDealUploadFileDealIdPost$Plain$Response(params: {
    dealId: number;
    filename?: string;
    isBom?: boolean;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<QuoteFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUploadFileDealIdPostPath, 'post');
    if (params) {
      rb.path('dealId', params.dealId, {});
      rb.query('filename', params.filename, {});
      rb.query('isBom', params.isBom, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuoteFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUploadFileDealIdPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiDealUploadFileDealIdPost$Plain(params: {
    dealId: number;
    filename?: string;
    isBom?: boolean;
    body?: { 'formFile'?: Blob }
  }): Observable<QuoteFileDtoBaseResponse> {

    return this.apiDealUploadFileDealIdPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<QuoteFileDtoBaseResponse>) => r.body as QuoteFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUploadFileDealIdPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiDealUploadFileDealIdPost$Json$Response(params: {
    dealId: number;
    filename?: string;
    isBom?: boolean;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<QuoteFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUploadFileDealIdPostPath, 'post');
    if (params) {
      rb.path('dealId', params.dealId, {});
      rb.query('filename', params.filename, {});
      rb.query('isBom', params.isBom, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuoteFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUploadFileDealIdPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiDealUploadFileDealIdPost$Json(params: {
    dealId: number;
    filename?: string;
    isBom?: boolean;
    body?: { 'formFile'?: Blob }
  }): Observable<QuoteFileDtoBaseResponse> {

    return this.apiDealUploadFileDealIdPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<QuoteFileDtoBaseResponse>) => r.body as QuoteFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealUpdateFilePost
   */
  static readonly ApiDealUpdateFilePostPath = '/api/Deal/update-file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateFilePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateFilePost$Plain$Response(params?: {
    body?: QuoteFileDto
  }): Observable<StrictHttpResponse<QuoteFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuoteFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateFilePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateFilePost$Plain(params?: {
    body?: QuoteFileDto
  }): Observable<QuoteFileDtoBaseResponse> {

    return this.apiDealUpdateFilePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<QuoteFileDtoBaseResponse>) => r.body as QuoteFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateFilePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateFilePost$Json$Response(params?: {
    body?: QuoteFileDto
  }): Observable<StrictHttpResponse<QuoteFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuoteFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateFilePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateFilePost$Json(params?: {
    body?: QuoteFileDto
  }): Observable<QuoteFileDtoBaseResponse> {

    return this.apiDealUpdateFilePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<QuoteFileDtoBaseResponse>) => r.body as QuoteFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealDownloadFileFileIdGet
   */
  static readonly ApiDealDownloadFileFileIdGetPath = '/api/Deal/download-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDownloadFileFileIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDownloadFileFileIdGet$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDownloadFileFileIdGetPath, 'get');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDownloadFileFileIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDownloadFileFileIdGet(params: {
    fileId: number;
  }): Observable<string> {

    return this.apiDealDownloadFileFileIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiDealDeleteFileFileIdDelete
   */
  static readonly ApiDealDeleteFileFileIdDeletePath = '/api/Deal/delete-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDeleteFileFileIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDeleteFileFileIdDelete$Plain$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<QuoteFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDeleteFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuoteFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDeleteFileFileIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDeleteFileFileIdDelete$Plain(params: {
    fileId: number;
  }): Observable<QuoteFileDtoBaseResponse> {

    return this.apiDealDeleteFileFileIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<QuoteFileDtoBaseResponse>) => r.body as QuoteFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDeleteFileFileIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDeleteFileFileIdDelete$Json$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<QuoteFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDeleteFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuoteFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDeleteFileFileIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDeleteFileFileIdDelete$Json(params: {
    fileId: number;
  }): Observable<QuoteFileDtoBaseResponse> {

    return this.apiDealDeleteFileFileIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<QuoteFileDtoBaseResponse>) => r.body as QuoteFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealCommentsGet
   */
  static readonly ApiDealCommentsGetPath = '/api/Deal/comments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealCommentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealCommentsGet$Plain$Response(params?: {
    dealId?: number;
  }): Observable<StrictHttpResponse<DealCommentDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealCommentsGetPath, 'get');
    if (params) {
      rb.query('dealId', params.dealId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealCommentDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealCommentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealCommentsGet$Plain(params?: {
    dealId?: number;
  }): Observable<DealCommentDtoListBaseResponse> {

    return this.apiDealCommentsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealCommentDtoListBaseResponse>) => r.body as DealCommentDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealCommentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealCommentsGet$Json$Response(params?: {
    dealId?: number;
  }): Observable<StrictHttpResponse<DealCommentDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealCommentsGetPath, 'get');
    if (params) {
      rb.query('dealId', params.dealId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealCommentDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealCommentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealCommentsGet$Json(params?: {
    dealId?: number;
  }): Observable<DealCommentDtoListBaseResponse> {

    return this.apiDealCommentsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealCommentDtoListBaseResponse>) => r.body as DealCommentDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealAddCommentPost
   */
  static readonly ApiDealAddCommentPostPath = '/api/Deal/add-comment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddCommentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddCommentPost$Plain$Response(params?: {
    body?: DealCommentDto
  }): Observable<StrictHttpResponse<DealCommentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddCommentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealCommentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddCommentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddCommentPost$Plain(params?: {
    body?: DealCommentDto
  }): Observable<DealCommentDtoBaseResponse> {

    return this.apiDealAddCommentPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealCommentDtoBaseResponse>) => r.body as DealCommentDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddCommentPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddCommentPost$Json$Response(params?: {
    body?: DealCommentDto
  }): Observable<StrictHttpResponse<DealCommentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddCommentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealCommentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddCommentPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddCommentPost$Json(params?: {
    body?: DealCommentDto
  }): Observable<DealCommentDtoBaseResponse> {

    return this.apiDealAddCommentPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealCommentDtoBaseResponse>) => r.body as DealCommentDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealUpdateCommentPut
   */
  static readonly ApiDealUpdateCommentPutPath = '/api/Deal/update-comment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateCommentPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateCommentPut$Plain$Response(params?: {
    body?: DealCommentDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateCommentPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateCommentPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateCommentPut$Plain(params?: {
    body?: DealCommentDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateCommentPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateCommentPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateCommentPut$Json$Response(params?: {
    body?: DealCommentDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateCommentPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateCommentPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateCommentPut$Json(params?: {
    body?: DealCommentDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateCommentPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealDeleteCommentDelete
   */
  static readonly ApiDealDeleteCommentDeletePath = '/api/Deal/delete-comment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDeleteCommentDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDeleteCommentDelete$Plain$Response(params?: {
    commentId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDeleteCommentDeletePath, 'delete');
    if (params) {
      rb.query('commentId', params.commentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDeleteCommentDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDeleteCommentDelete$Plain(params?: {
    commentId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiDealDeleteCommentDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealDeleteCommentDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDeleteCommentDelete$Json$Response(params?: {
    commentId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealDeleteCommentDeletePath, 'delete');
    if (params) {
      rb.query('commentId', params.commentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealDeleteCommentDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealDeleteCommentDelete$Json(params?: {
    commentId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiDealDeleteCommentDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealUpdateSwimlanesPut
   */
  static readonly ApiDealUpdateSwimlanesPutPath = '/api/Deal/update-swimlanes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateSwimlanesPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateSwimlanesPut$Plain$Response(params?: {
    body?: Array<DealStageDetailDto>
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateSwimlanesPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateSwimlanesPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateSwimlanesPut$Plain(params?: {
    body?: Array<DealStageDetailDto>
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateSwimlanesPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateSwimlanesPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateSwimlanesPut$Json$Response(params?: {
    body?: Array<DealStageDetailDto>
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateSwimlanesPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateSwimlanesPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateSwimlanesPut$Json(params?: {
    body?: Array<DealStageDetailDto>
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateSwimlanesPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealUpdateCardPositionsPut
   */
  static readonly ApiDealUpdateCardPositionsPutPath = '/api/Deal/update-card-positions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateCardPositionsPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateCardPositionsPut$Plain$Response(params?: {
    body?: Array<DealDto>
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateCardPositionsPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateCardPositionsPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateCardPositionsPut$Plain(params?: {
    body?: Array<DealDto>
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateCardPositionsPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateCardPositionsPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateCardPositionsPut$Json$Response(params?: {
    body?: Array<DealDto>
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateCardPositionsPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateCardPositionsPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateCardPositionsPut$Json(params?: {
    body?: Array<DealDto>
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateCardPositionsPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealGetRemindersGet
   */
  static readonly ApiDealGetRemindersGetPath = '/api/Deal/get-reminders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealGetRemindersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealGetRemindersGet$Plain$Response(params?: {
    dealId?: number;
    userId?: number;
  }): Observable<StrictHttpResponse<DealReminderDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealGetRemindersGetPath, 'get');
    if (params) {
      rb.query('dealId', params.dealId, {});
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealReminderDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealGetRemindersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealGetRemindersGet$Plain(params?: {
    dealId?: number;
    userId?: number;
  }): Observable<DealReminderDtoListBaseResponse> {

    return this.apiDealGetRemindersGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealReminderDtoListBaseResponse>) => r.body as DealReminderDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealGetRemindersGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealGetRemindersGet$Json$Response(params?: {
    dealId?: number;
    userId?: number;
  }): Observable<StrictHttpResponse<DealReminderDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealGetRemindersGetPath, 'get');
    if (params) {
      rb.query('dealId', params.dealId, {});
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealReminderDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealGetRemindersGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealGetRemindersGet$Json(params?: {
    dealId?: number;
    userId?: number;
  }): Observable<DealReminderDtoListBaseResponse> {

    return this.apiDealGetRemindersGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealReminderDtoListBaseResponse>) => r.body as DealReminderDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealAddReminderPost
   */
  static readonly ApiDealAddReminderPostPath = '/api/Deal/add-reminder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddReminderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddReminderPost$Plain$Response(params?: {
    body?: DealReminderDto
  }): Observable<StrictHttpResponse<DealReminderDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddReminderPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealReminderDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddReminderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddReminderPost$Plain(params?: {
    body?: DealReminderDto
  }): Observable<DealReminderDtoBaseResponse> {

    return this.apiDealAddReminderPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealReminderDtoBaseResponse>) => r.body as DealReminderDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddReminderPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddReminderPost$Json$Response(params?: {
    body?: DealReminderDto
  }): Observable<StrictHttpResponse<DealReminderDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddReminderPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealReminderDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddReminderPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealAddReminderPost$Json(params?: {
    body?: DealReminderDto
  }): Observable<DealReminderDtoBaseResponse> {

    return this.apiDealAddReminderPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealReminderDtoBaseResponse>) => r.body as DealReminderDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealUpdateReminderPut
   */
  static readonly ApiDealUpdateReminderPutPath = '/api/Deal/update-reminder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateReminderPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateReminderPut$Plain$Response(params?: {
    body?: DealReminderDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateReminderPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateReminderPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateReminderPut$Plain(params?: {
    body?: DealReminderDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateReminderPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealUpdateReminderPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateReminderPut$Json$Response(params?: {
    body?: DealReminderDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealUpdateReminderPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealUpdateReminderPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealUpdateReminderPut$Json(params?: {
    body?: DealReminderDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealUpdateReminderPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealArchiveReminderDelete
   */
  static readonly ApiDealArchiveReminderDeletePath = '/api/Deal/archive-reminder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealArchiveReminderDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveReminderDelete$Plain$Response(params?: {
    reminderId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealArchiveReminderDeletePath, 'delete');
    if (params) {
      rb.query('reminderId', params.reminderId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealArchiveReminderDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveReminderDelete$Plain(params?: {
    reminderId?: number;
    archive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiDealArchiveReminderDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealArchiveReminderDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveReminderDelete$Json$Response(params?: {
    reminderId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealArchiveReminderDeletePath, 'delete');
    if (params) {
      rb.query('reminderId', params.reminderId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealArchiveReminderDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealArchiveReminderDelete$Json(params?: {
    reminderId?: number;
    archive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiDealArchiveReminderDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiDealAddWorkingDaysGet
   */
  static readonly ApiDealAddWorkingDaysGetPath = '/api/Deal/add-working-days';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddWorkingDaysGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealAddWorkingDaysGet$Plain$Response(params?: {
    date?: string;
    days?: number;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddWorkingDaysGetPath, 'get');
    if (params) {
      rb.query('date', params.date, {});
      rb.query('days', params.days, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddWorkingDaysGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealAddWorkingDaysGet$Plain(params?: {
    date?: string;
    days?: number;
  }): Observable<string> {

    return this.apiDealAddWorkingDaysGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealAddWorkingDaysGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealAddWorkingDaysGet$Json$Response(params?: {
    date?: string;
    days?: number;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealAddWorkingDaysGetPath, 'get');
    if (params) {
      rb.query('date', params.date, {});
      rb.query('days', params.days, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealAddWorkingDaysGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDealAddWorkingDaysGet$Json(params?: {
    date?: string;
    days?: number;
  }): Observable<string> {

    return this.apiDealAddWorkingDaysGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiDealNewEnquiryPost
   */
  static readonly ApiDealNewEnquiryPostPath = '/api/Deal/new-enquiry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealNewEnquiryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealNewEnquiryPost$Plain$Response(params?: {
    body?: EnquiryDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealNewEnquiryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealNewEnquiryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealNewEnquiryPost$Plain(params?: {
    body?: EnquiryDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealNewEnquiryPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDealNewEnquiryPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealNewEnquiryPost$Json$Response(params?: {
    body?: EnquiryDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DealService.ApiDealNewEnquiryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDealNewEnquiryPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDealNewEnquiryPost$Json(params?: {
    body?: EnquiryDto
  }): Observable<BooleanBaseResponse> {

    return this.apiDealNewEnquiryPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
